import api from "../api";

export const createCaptureTransaction = async (payload) => {
  return api.post("/v0/capture", payload).then((res) => res.data);
}
  
export const getCaptureTransaction = async (token) => {
  return api.get(`/v0/capture`, {
    params: {
      token: token,
    },
  }).then((res) => res.data);
}
  